function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1f2a;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M231.71,546.29l32-40.78a1.63,1.63,0,0,1,1.29-.63h29.12a.82.82,0,0,1,.64,1.33l-32.41,41.08,33.87,42a.82.82,0,0,1-.64,1.33H265a1.63,1.63,0,0,1-1.29-.63l-32-41.7A1.64,1.64,0,0,1,231.71,546.29Z",
  transform: "translate(-204.05 -488.23)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M370.13,537.43V506.52a1.63,1.63,0,0,1,1.64-1.64h23.68a1.64,1.64,0,0,1,1.64,1.64V589a1.64,1.64,0,0,1-1.64,1.64H371.77a1.63,1.63,0,0,1-1.64-1.64V556H338v33a1.63,1.63,0,0,1-1.63,1.64H312.65A1.64,1.64,0,0,1,311,589V506.52a1.64,1.64,0,0,1,1.64-1.64h23.69a1.63,1.63,0,0,1,1.63,1.64v30.91Z",
  transform: "translate(-204.05 -488.23)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M476.87,578.34c-8.55,9.86-16.91,13.95-27.7,13.95-16.91,0-31.41-10.41-31.41-32.54V506.52a1.63,1.63,0,0,1,1.63-1.64h23.69a1.64,1.64,0,0,1,1.64,1.64v51.36c0,12.09,6.5,16.37,13.56,16.37,8.18,0,15.62-6.32,18.41-14.69v-53a1.63,1.63,0,0,1,1.63-1.64h23.87a1.63,1.63,0,0,1,1.64,1.64V589a1.63,1.63,0,0,1-1.64,1.64H478.51a1.64,1.64,0,0,1-1.64-1.64Z",
  transform: "translate(-204.05 -488.23)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M608.86,547.29h.37",
  transform: "translate(-204.05 -488.23)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M828.52,592.29c-28.07,0-48.52-17.66-48.52-44.63,0-29.2,23.24-44.45,48.52-44.45,21,0,48.15,11.72,48.15,44.63C876.67,581.88,847.48,592.29,828.52,592.29Zm0-73.09c-11.71,0-19.7,9.12-19.7,28.46,0,22.13,9.47,28.64,19.7,28.64,12.64,0,19.33-10.42,19.33-29.2C847.85,530.36,842.09,519.2,828.52,519.2Z",
  transform: "translate(-204.05 -488.23)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 26.95,
  height: 102.39,
  rx: 1.63
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M713.37,546.29l32-40.78a1.63,1.63,0,0,1,1.29-.63h29.12a.82.82,0,0,1,.64,1.33L744,547.29l33.87,42a.82.82,0,0,1-.64,1.33H746.66a1.63,1.63,0,0,1-1.29-.63l-32-41.7A1.64,1.64,0,0,1,713.37,546.29Z",
  transform: "translate(-204.05 -488.23)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 481.66,
  width: 26.95,
  height: 102.39,
  rx: 1.63
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M609.64,546.29l32-40.78a1.63,1.63,0,0,1,1.29-.63h29.12a.82.82,0,0,1,.64,1.33l-32.41,41.08,33.87,42a.82.82,0,0,1-.63,1.33H642.93a1.63,1.63,0,0,1-1.29-.63l-32-41.7A1.64,1.64,0,0,1,609.64,546.29Z",
  transform: "translate(-204.05 -488.23)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M581.29,548.29l-32,41.7a1.62,1.62,0,0,1-1.28.63H517.41a.82.82,0,0,1-.64-1.33l33.88-42-32.42-41.08a.82.82,0,0,1,.64-1.33H548a1.62,1.62,0,0,1,1.28.63l32,40.78A1.62,1.62,0,0,1,581.29,548.29Z",
  transform: "translate(-204.05 -488.23)"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 377.93,
  width: 26.95,
  height: 102.39,
  rx: 1.63
});

var SvgKnijkoWordmark = function SvgKnijkoWordmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 672.62 104.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKnijkoWordmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/knijko-wordmark.3ff6b0e7.svg";
export { ForwardRef as ReactComponent };